export const appName = state => state.appName;
export const baseURL = state => state.baseURL;
export const loading = state => state.loading;
export const errors = state => state.errors;
export const selected_user = state => state.selected_user;
export const storageDir = state => state.storageDir;